import { CSSProperties } from 'react';
import styles from 'styles/components/common/forms/SearchInput.module.scss';
import { ReactComponent as SearchIcon } from 'assets/icons/search.svg';
import { STYLES_VARIABLES } from 'constants/styleVariables';
import Input from './Input';

type TProps = {
  inputWrapperStyle: CSSProperties;
  inputStyle: CSSProperties;
  placeholderText: string;
  name: string;
  handleEnter?: () => void;
};

const SearchInput = ({
  inputWrapperStyle,
  inputStyle,
  placeholderText,
  name,
  handleEnter,
}: TProps) => {
  return (
    <div className={styles.input_wrapper} style={inputWrapperStyle}>
      <SearchIcon width={24} height={24} fill={STYLES_VARIABLES.GRAY_08} />
      <Input
        inputType="text"
        name={name}
        inputStyle={inputStyle}
        placeholderText={placeholderText}
        handleEnter={handleEnter}
      />
    </div>
  );
};

export default SearchInput;
